<template>
  <div class="vx-col w-full lg:w-1/3 sm:w-full mb-base">
    <vx-card>
      <span class="title-head">ชำระเงินงวดปัจจุบัน</span><br><br><br>
      <span class="label-bold">ยอดหนี้ที่ต้องชำระในงวดปัจจุบัน</span><br><br>
      <div class="vx-row flex" v-if="paidFee > 0 && paymentAmount > 0">
        <span class="vx-col flex-1 text-left label">ค่าธรรมเนียม</span>
        <span class="vx-col flex-1 text-right label-bold">{{ paidFee | numberFormat }}</span>
      </div>
      <div class="vx-row flex" v-if="paidPenalty > 0 && paymentAmount > 0">
        <span class="vx-col flex-1 text-left label">เบี้ยปรับ</span>
        <span class="vx-col flex-1 text-right label-bold">{{ paidPenalty | numberFormat }}</span>
      </div>
      <div class="vx-row flex" v-if="paidInterest > 0 && paymentAmount > 0">
        <span class="vx-col flex-1 text-left label">ดอกเบี้ย</span>
        <span class="vx-col flex-1 text-right label-bold">{{ paidInterest | numberFormat }}</span>
      </div>
      <div class="vx-row flex" v-if="paidPrinciple > 0 && paymentAmount > 0">
        <span class="vx-col flex-1 text-left label">เงินต้น</span>
        <span class="vx-col flex-1 text-right label-bold">{{ paidPrinciple | numberFormat }}</span>
      </div>
      <div class="vx-row flex" v-for="index in paidSpace" :key="index">
        <span class="vx-col flex-1 text-left label">&nbsp;</span>
        <span class="vx-col flex-1 text-right label-bold">&nbsp;</span>
      </div>
      <br>

      <div class="vx-row flex">
        <span class="vx-col flex-1 text-left label">กำหนดชำระภายใน</span>
        <span class="vx-col flex-1 text-right label-bold">{{ paymentRoundDate }}</span>
      </div><br>

      <div class="vx-row flex">
        <span class="vx-col flex-1 text-left label">ยอดรวม</span>
        <div class="vx-col flex-1 text-right"><span class="money-bold">{{ paymentAmount | numberFormat }} </span> <span class="label-bold">บาท</span></div>
      </div><br>

      <vs-button type="filled" :disabled="disabledSubmit" class="w-full" color="primary" @click="btnQrPayment('normal', 0)">ชำระเงิน</vs-button>
    </vx-card>
  </div>
</template>

<script>

const moment = require('moment');
import { createNamespacedHelpers } from 'vuex'
const { mapState: mapAccountingState } = createNamespacedHelpers('Accounting')

export default {
  name: "PaymentNormal",
  props: {
    btnQrPayment: Function,
  },
  computed: {
    ...mapAccountingState(['status', 'paymentAmountDetailNormal', 'paymentAmountDetailOutstanding', 'paymentRoundDetail', 'contract', 'loan', 'qrPayment']),
    disabledSubmit() {
      if( this.paymentAmount <= 0 ) { return true }
      else { return false }
    },
    closingBalanceAmount(){
      if(!this.loan) return 0.00
      return this.loan.accruedFeeRemain + this.loan.accruedPenaltyRemain + this.loan.accruedInterestRemain + this.loan.principleRemain - this.loan.balanceRemain
    },
    paymentRoundDate(){
      if(this.contract.loan && this.paymentRoundDetail){
        return this.$options.filters.toThaiDDMMMYYYYFormat(moment(this.paymentRoundDetail.paymentRoundDate).format("YYYY-MM-DD"))
      }else{
        return "-"
      }
    },
    lastPaymentRoundDate(){
      if(this.contract.loan && this.paymentRoundDetail){
        return this.$options.filters.toThaiDDMMMYYYYFormat(moment(this.paymentRoundDetail.lastPaymentRoundDate).add(this.contract.loan.coDate, 'days').format("YYYY-MM-DD"))
      }else{
        return "-"
      }
    },
    nowUpdate(){
      const vm = this
      if( vm.contract.loan && vm.paymentAmountDetailNormal){
        if(vm.paymentRoundDetail.paymentRoundType === "Interest"){
          return vm.$options.filters.toThaiDDMMMYYYYFormat(moment(vm.paymentAmountDetailNormal.paymentRoundDate).format("YYYY-MM-DD"))
        }else{
          return vm.$options.filters.toThaiDDMMMYYYYFormat(moment(vm.contract.loan.lastUpdate).add(1, 'days').format("YYYY-MM-DD"))
        }
      }else{
        return "-"
      }
    },
    paidSpace(){
      let space = 4
      if(this.paidFee >= 1) space--
      if(this.paidPenalty >= 1) space--
      if(this.paidInterest >= 1) space--
      if(this.paidPrinciple >= 1) space--
      return space
    },
    paymentAmount(){
      if(!this.paymentAmountDetailNormal) return 0.00
      return this.paymentAmountDetailNormal.amount
    },
    paidFee(){
      if(!this.paymentAmountDetailNormal) return 0.00
      return this.paymentAmountDetailNormal.paidFee
    },
    paidPenalty(){
      if(!this.paymentAmountDetailNormal) return 0.00
      return this.paymentAmountDetailNormal.paidPenalty
    },
    paidInterest(){ //accruedInterestRemain
      if(!this.paymentAmountDetailNormal) return 0.00
      return this.paymentAmountDetailNormal.paidInterest
    },
    paidPrinciple(){
      if(!this.paymentAmountDetailNormal) return 0.00
      return this.paymentAmountDetailNormal.paidPrinciple
    },
  },
}
</script>

<style scoped>

</style>
